import LoadingConstants from 'app/shared/constants/LoadingConstants';
import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    currentInvoice: null,
    currentInvoiceFilters: {},
    currentInvoiceLoadingState: LoadingConstants.INITIAL,
    currentInvoiceErrorMessage: null,
});

const invoice = (state = initState(), action = {}) => {
    const { type } = action;

    switch (type) {
        case DispatchConstants.BILLING_SET_INVOICE_FILTERS:
            return {
                ...state,
                currentInvoiceFilters: action.payload,
            };
        case DispatchConstants.BILLING_IMPORT_INVOICE:
            return {
                ...state,
                currentInvoice: action.payload.invoice,
                currentInvoiceFilters: action.payload.currentInvoiceFilters,
                currentInvoiceLoadingState: LoadingConstants.SUCCESS,
                currentInvoiceErrorMessage: null,
            };
        case DispatchConstants.BILLING_SET_CURRENT_INVOICE_PAYMENT_IN_PROGRESS:
            return {
                ...state,
                currentInvoice: {
                    ...state.currentInvoice,
                    isPaymentInProgress: action.payload.isPaymentInProgress,
                },
            };
        case DispatchConstants.BILLING_SET_CURRENT_INVOICE_LOADING_STATE:
            return {
                ...state,
                currentInvoiceLoadingState: action.payload,
            };
        case DispatchConstants.BILLING_SET_CURRENT_INVOICE_ERROR_MESSAGE:
            return {
                ...state,
                currentInvoiceErrorMessage: action.payload,
            };
        case DispatchConstants.BILLING_CLEAR_CURRENT_INVOICE:
            return initState();
        default:
            return state;
    }
};

export default invoice;
